export default {
  'marketplace': [
    {
      name: 'basic-info',
      title: 'Basic info',
      routes: [
        {
          route: '/waypoint-0',
          enabled: false,
          enabledP: false,
        },
        {
          route: '/basic-info',
          visited: true,
          enabledP: ['progress', '!returnAppExperience'],
          isCompleteP: ['progress', 'basicInfoComplete'],
        },
        {
          route: '/updated-info',
          visited: true,
          enabledP: ['progress', 'returnAppExperience'],
          isCompleteP: ['progress', 'basicInfoComplete'],
        },
        {
          route: '/waypoint-1',
          enabledP: ['progress', 'basicInfoWaypoint'],
        }
      ],
      adoptedRoutes: [
        '/basic-info-new/?[^\/]*',
        '/waypoint-0',
        '/waypoint-1'
      ]
    },
    {
      name: 'funding-needs',
      title: 'Funding needs',
      routes: [
        {
          route: '/funding-needs',
          enabledP: ['fundingNeeds', 'showFundingNeeds'],
          isCompleteP: ['progress', 'fundingNeedsComplete']
        }
      ],
    },
    {
      name: 'owner-info',
      title: 'Owner info',
      routes: [
        {
          route: '/owner-info',
          enabledP: ['user', '!hasOptimusUser'],
          visitedP: ['progress', 'hasSeenOwnerInfo'],
          isCompleteP: ['progress', 'ownerInfoComplete']
        },
        {
          route: '/owner-info/owner-info-2',
          visitedP: ['progress', 'hasSeenOwnerInfo'],
        },
        {
          route: '/owner-info/owner-info-3',
          requiredActions: {
            actionsP: [
              ['experienceAction', 'getExperience']
            ],
          }
        },
        {
          route: '/owner-info/owner-info-4',
          enabledP: ['experience', '!isDNQ']
        }
      ],
      adoptedRoutes: [
        '/sso-signup',
        '/pwf-signup',
        '/verify-email',
        '/login-sso',
        '/newpass',
      ]
    },
    {
      name: 'business-info',
      title: 'Business info',
      routes: [
        { route: '/business-info' },
        {
          route: '/business-info/business-info-2',
          enabledP: ['questions', 'hasQuestions', 'businessFinancialQuestions']
        },
        {
          route: '/business-info/business-info-3',
          enabledP: ['questions', 'hasQuestions', 'additionalQuestions']
        }
      ]
    },
    {
      name: 'documents',
      title: 'Documents',
      routes: [
        {
          route: '/documents',
          enabledP: ['document', 'documentsPageAllowed'],
          requiredActions: {
            filterP: ['user', 'hasOptimusUser'],
            actionsP: [
              ['documentAction', 'getDocuments'],
              ['experienceAction', 'getExperience'],
            ],
          }
        },
        {
          route: '/documents/results',
          enabledP: ['document', 'hasOfTypes', [{ type: 'bankStatement', min: 3 }]],
          visitedP: ['document', 'hasOfTypes', [{ type: 'bankStatement', min: 3 }]],
        }
      ],
      adoptedRoutes: [
        '/documents/manual',
        '/documents/accounts',
        '/documents/sync',
        '/documents/statement-error',
        '/documents/sync-error',
      ]
    },
    {
      name: 'submit',
      title: 'Submit',
      routes: [
        {
          route: '/submit',
          isCompleteP: ['borrower', 'mpApplicationComplete']
        },
      ]
    }
  ],
  'renewal' : [
    {
      name: 'renewal',
      title: 'Verify Information',
      visited: true,
      routes: [
        {route: '/renewal'},
        {route: '/renewal/business-info'}
      ]
    },
    {
      name: 'new-loan-requirements',
      title: 'New Loan Requirements',
      routes: [
        {route: '/renewal/new-loan-requirements'}
      ]
    },
    {
      name: 'documents',
      title: 'Financial Review',
      routes: [
        {route: '/renewal/documents'},
      ],
      adoptedRoutes: [
        '/renewal/documents/manual'
      ]
    },
    {
      name: 'credit-check',
      title: 'Credit Check',
      routes: [
        {route: '/renewal/credit-check'},
        {route: '/renewal/credit-check/review'}
      ]
    },
    {
      name: 'submit',
      title: 'Terms and Agreement',
      enabledP: ['borrower', 'signatureExpired'],
      routes: [
        {route: '/renewal/submit'}
      ]
    },

  ],
  'erc' : [
    {
      name: 'erc-signup',
      title: 'Create Account',
      enabledP: ['user', '!hasOptimusUser'],
      routes: [
        {route: '/erc'}
      ]
    },
    {
      name: 'erc-info-gathering',
      title: 'Basic Info',
      routes: [
        {
          route: '/erc/qualifications',
          isCompleteP: ['borrower', 'hasCompletedErcQualifications'],
          requiredActions: {
            actions: [
              'borrower/getBorrowerValues',
            ],
            actionsP: [
              ['borrowerAction', 'getBorrowerValues'],
            ]
          }
        },
        { route: '/erc/basic-info', }
      ]
    },
    {
      name: 'erc-ownership-info',
      title: 'Owner Info',
      routes: [
        {
          //This is the "old" ownership-info page that we want adesso users to see, not the new flow
          route: '/erc/ownership-info-tenant',
          //Enable this route based on environment variable for adesso
          enabledP: ['tenant', 'isTenant'],
          requiredActions: {
            actions: [
              'borrower/getBorrowerValues',
            ],
            actionsP: [
              ['borrowerAction', 'getBorrowerValues'],
            ]
          }
        },
        //These new routes we need to not be seen by adesso
        {
          route: '/erc/ownership-info',
          enabledP: ['tenant', '!isTenant'],
          requiredActions: {
            actions: [
              'borrower/getBorrowerValues',
            ],
            actionsP: [
              ['borrowerAction', 'getBorrowerValues'],
            ]
          }
        },
        {
          route: '/erc/ownership-info/additional-businesses',
          enabledP: ['ercOwnershipInfo', 'showAdditionalBusinesses']
        },
        {
          route: '/erc/ownership-info/related-owners',
          enabledP: ['ercOwnershipInfo', 'showRelatedOwners']
        },
        {
          route: '/erc/ownership-info/spouse-owned-businesses',
          enabledP: ['ercOwnershipInfo', 'showSpouseOwnedBusinesses']
        },
        {
          route: '/erc/ownership-info/owner-related-employees',
          enabledP: ['ercOwnershipInfo', 'showOwnerRelatedEmployees']
        }
      ]
    },
    {
      name: 'erc-checklist',
      title: 'Checklist',
      routes: [
        { route: '/erc/checklist', },
        { route: '/erc/government-order' },
        { route: '/erc/government-order/government-order-2', },
        { route: '/erc/government-order/government-order-3', },
        { route: '/erc/government-order/prevented-customer-access', },
        { route: '/erc/government-order/reduction-in-customers-served', },
        { route: '/erc/government-order/reduction-in-contracts', },
        { route: '/erc/government-order/projects-affected', },
        { route: '/erc/government-order/production-declined', },
        { route: '/erc/government-order/sales-reduced', },
        { route: '/erc/government-order/reduced-hours', },
        { route: '/erc/government-order/staggered-shifts', },
        { route: '/erc/government-order/workspace-modifications', },
        { route: '/erc/government-order/capacity-limitation', },
        { route: '/erc/government-order/in-person-meetings-affected', },
        { route: '/erc/government-order/suppliers-shutdown', },
      ],
      adoptedRoutes: [
        '/erc/business-info',
        '/erc/ppp-info',
        '/erc/payroll/manual',
        '/erc/peo-info',
        '/erc/government-order-info',
        '/erc/grant-credit-info',
        '/erc/revenue-info',
        '/erc/tax-documents',
        // multi government order pages
        '/erc/government-order',
        '/erc/government-order/government-order-2',
        '/erc/government-order/government-order-3',
        '/erc/government-order/prevented-customer-access',
        '/erc/government-order/reduction-in-customers-served',
        '/erc/government-order/reduction-in-contracts',
        '/erc/government-order/projects-affected',
        '/erc/government-order/production-declined',
        '/erc/government-order/sales-reduced',
        '/erc/government-order/reduced-hours',
        '/erc/government-order/staggered-shifts',
        '/erc/government-order/workspace-modifications',
        '/erc/government-order/capacity-limitation',
        '/erc/government-order/in-person-meetings-affected',
        '/erc/government-order/suppliers-shutdown',
      ]
    },
  ],
  'embedded' : [
    {
      name: 'owner-info',
      title: 'Owner Info',
      routes: [
        {
          route: '/embedded',
          visited: true,
        },
      ]
    },
    {
      name: 'business-info',
      title: 'Business Info',
      routes: [
        {
          route: '/embedded/business-info',
        },
        {
          route: '/embedded/credit-check',
          enabledP: ['affiliateCustomizations', 'creditCheckEnabled'],
        },
        {
          route: '/embedded/credit-check-result',
          enabledP: ['affiliateCustomizations', 'creditCheckShowSuccessPage'],
        },
      ]
    },
    {
      name: 'documents',
      title: 'Documents',
      routes: [
        {
          route: '/embedded/documents',
          requiredActions: {
            actionsP: [
              ['borrowerAction', 'getBorrowerValues'],
              ['documentAction', 'getDocuments'],
            ],
          },
          enabledP: ['affiliateCustomizations', 'documentsEnabled']
        },
        {
          route: '/embedded/documents/results',
          visitedP: ['document', 'hasOfTypes', [{ type: 'bankStatement', min: 3 }]],
          enabledP: ['affiliateCustomizations', 'documentsEnabled']
        }
      ],
      adoptedRoutes: [
        '/embedded/documents/manual',
        '/embedded/documents/accounts',
        '/embedded/documents/sync',
        '/embedded/documents/statement-error',
        '/embedded/documents/sync-error',
      ]
    },
    {
      name: 'submit',
      title: 'Submit',
      routes: [
        {
          route: '/embedded/submit',
        },
      ]
    },
  ],
  'sba' : [
    // Show a bank statments navItem that links to documents results page
    {
      name: 'bank-statements',
      title: 'Bank Statements',
      routes: [
        {
          route: '/documents/results',
          isCompleteP: ['document', 'hasOfTypes', [{ type: 'bankStatement', min: 3 }]],
          visited: true
        },
      ],
      visited: true,
    },
    {
      name: 'tax-returns',
      title: 'Tax Returns',
      routes: [
        {
          route: '/sba/tax-returns',
          isCompleteP: ['document', 'hasOfTypes', [{ type: 'businessTaxReturns', min: 2 }, { type: 'personalTaxReturns', min: 2 }]],
          progressCardMissingText: 'Finish uploading your tax returns for your enhanced loan application.'
        },
      ],
      visited: true,
    },
    {
      name: 'debt-schedule',
      title: 'Debt Schedule',
      routes: [
        {
          route: '/sba/debt-schedule',
          progressCardMissingText: 'Finish uploading your Debt Schedule for your enhanced loan application.'
        },
        {
          route: '/sba/debt-schedule-upload',
          enabledP: ['borrower', 'hasBusinessDebt'],
          isCompleteP: ['borrower', 'debtScheduleComplete'],
          progressCardMissingText: 'Finish uploading your Debt Schedule for your enhanced loan application.'
        },
      ],
      visited: true,
    },
    {
      name: 'profit-and-loss',
      title: 'YTD Profit & Loss',
      routes: [
        {
          route: '/sba/profit-and-loss',
          isCompleteP: ['document', 'hasOfTypes', [{ type: 'pLCurrentYear' }]],
          progressCardMissingText: 'Finish uploading your YTD P&L Statement for your enhanced loan application.'
        },
      ],
      visited: true,
    },
    {
      name: 'balance-sheet',
      title: 'YTD Balance Sheet',
      routes: [
        {
          route: '/sba/balance-sheet',
          isCompleteP: ['document', 'hasOfTypes', [{ type: 'balanceSheet' }]],
          progressCardMissingText: 'Finish uploading your YTD Balance Sheet for your enhanced loan application.'
        },
      ],
      visited: true,
    }
  ],
  'sba-complete': [
    {
      name: 'sba-complete-basic-info',
      title: 'Basic info',
      routes: [
        {
          route: '/sba-complete/basic-info',
          visited: true,
        }
      ]
    },
    {
      name: 'sba-complete-owner-info',
      title: 'Owner info',
      routes: [
        {
          route: '/sba-complete/owner-info',
          enabledP: ['user', '!hasOptimusUser'],
        },
        {
          route: '/sba-complete/owner-info/owner-info-2',
        },
        {
          route: '/sba-complete/owner-info/owner-info-3',
        }
      ],
    },
    {
      name: 'sba-complete-business-info',
      title: 'Business info',
      routes: [
        {
          route: '/sba-complete/business-info'
        },
        {
          route: '/sba-complete/business-info/business-info-2',
          enabledP: ['questions', 'hasQuestions', 'businessFinancialQuestions']
        },
        {
          route: '/sba-complete/business-info/business-info-3',
          enabledP: ['questions', 'hasQuestions', 'additionalQuestions']
        }
      ]
    },
    {
      name: 'sba-complete-bank-statements',
      title: 'Bank statements',
      routes: [
        {
          route: '/sba-complete/documents',
          requiredActions: {
            filterP: ['user', 'hasOptimusUser'],
            actionsP: [
              ['documentAction', 'getDocuments'],
            ],
          }
        },
        {
          route: '/sba-complete/documents/results',
          enabledP: ['document', 'hasOfTypes', [{ type: 'bankStatement', min: 3 }]],
          visitedP: ['document', 'hasOfTypes', [{ type: 'bankStatement', min: 3 }]],
          requiredActions: {
            filterP: ['user', 'hasOptimusUser'],
            actionsP: [
              ['documentAction', 'getDocuments'],
            ],
          }
        }
      ],
      adoptedRoutes: [
        '/sba-complete/documents/manual',
        '/sba-complete/documents/accounts',
        '/sba-complete/documents/sync',
        '/sba-complete/documents/statement-error',
        '/sba-complete/documents/sync-error',
      ]
    },
    {
      name: 'sba-complete-tax-returns',
      title: 'Tax returns',
      routes: [
        {
          route: '/sba-complete/tax-returns',
          isCompleteP: ['document', 'hasOfTypes', [{ type: 'businessTaxReturns', min: 2 }, { type: 'personalTaxReturns', min: 2 }]],
          progressCardMissingText: 'Finish uploading your tax returns for your SBA loan application.',
          requiredActions: {
            filterP: ['user', 'hasOptimusUser'],
            actionsP: [
              ['documentAction', 'getDocuments'],
            ],
          }
        },
      ],
    },
    {
      name: 'sba-complete-debt-schedule',
      title: 'Debt schedule',
      routes: [
        {
          route: '/sba-complete/debt-schedule',
          progressCardMissingText: 'Finish uploading your Debt Schedule for your SBA loan application.'
        },
        {
          route: '/sba-complete/debt-schedule-upload',
          enabledP: ['borrower', 'hasBusinessDebt'],
          isCompleteP: ['borrower', 'debtScheduleComplete'],
          progressCardMissingText: 'Finish uploading your Debt Schedule for your SBA loan application.'
        },
      ]
    },
    {
      name: 'sba-complete-profit-and-loss',
      title: 'YTD profit & loss',
      routes: [
        {
          route: '/sba-complete/profit-and-loss',
          isCompleteP: ['document', 'hasOfTypes', [{ type: 'pLCurrentYear' }]],
          progressCardMissingText: 'Finish uploading your YTD P&L Statement for your SBA loan application.'
        },
      ],
    },
    {
      name: 'sba-complete-balance-sheet',
      title: 'YTD balance sheet',
      routes: [
        {
          route: '/sba-complete/balance-sheet',
          isCompleteP: ['document', 'hasOfTypes', [{ type: 'balanceSheet' }]],
          progressCardMissingText: 'Finish uploading your YTD Balance Sheet for your SBA loan application.'
        },
      ],
    },
    {
      name: 'sba-complete-submit',
      title: 'Submit',
      routes: [
        {
          route: '/sba-complete/submit',
          isCompleteP: ['borrower', 'mpApplicationComplete']
        },
      ]
    },
  ],
}
